// extracted by mini-css-extract-plugin
module.exports = {"header-message":"header-message__2GKx7"};